export default "__VITE_ASSET__fea43e66__"